class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    if (!this.mainDetailsToggle) return;
    var summary = this.mainDetailsToggle.querySelector('summary');
    this.content = summary ? summary.nextElementSibling : null;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut(e) {
    const nextFocus = e.relatedTarget;
    setTimeout(() => {
      const stillInside = this.contains(document.activeElement);
      const focusMovedInside = nextFocus != null && this.contains(nextFocus);
      if (!stillInside && !focusMovedInside) this.close();
    });
  }

  onToggle() {
    if (!this.mainDetailsToggle || !this.content) return;
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    if (!this.mainDetailsToggle) return;
    this.mainDetailsToggle.removeAttribute('open');
    var summary = this.mainDetailsToggle.querySelector('summary');
    if (summary) summary.setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.hoverTimeout = null;
    this.initHover();
  }

  initHover() {
    if (!this.mainDetailsToggle) return;
    const summary = this.querySelector('summary');
    if (!summary) return;

    const menuLink = summary.querySelector('.ec-header-menu-link')

		summary.addEventListener('mouseenter', () => {
			if (this.hoverTimeout) {
				clearTimeout(this.hoverTimeout)
				this.hoverTimeout = null
			}

			if (!this.mainDetailsToggle.hasAttribute('open')) {
				this.mainDetailsToggle.setAttribute('open', '')
				summary.setAttribute('aria-expanded', 'true')
			}
		})

		this.addEventListener('mouseleave', (e) => {
			const relatedTarget = e.relatedTarget

			if (!relatedTarget) {
				this.hoverTimeout = setTimeout(() => {
					if (this.mainDetailsToggle.hasAttribute('open')) {
						this.close()
					}
				}, 800)
				return
			}

			const dropdownWrapper = this.querySelector('.ec-fixed-dropdown-wrapper')
			const isInsideMenu = this.contains(relatedTarget)
			const isInsideDropdown = dropdownWrapper && dropdownWrapper.contains(relatedTarget)

			if (!isInsideMenu && !isInsideDropdown) {
				this.hoverTimeout = setTimeout(() => {
					if (this.mainDetailsToggle.hasAttribute('open')) {
						this.close()
					}
				}, 800)
			} else {
				if (this.hoverTimeout) {
					clearTimeout(this.hoverTimeout)
					this.hoverTimeout = null
				}
			}
		})

		const dropdownWrapper = this.querySelector('.ec-fixed-dropdown-wrapper')
		if (dropdownWrapper) {
			dropdownWrapper.addEventListener('mouseenter', () => {
				if (this.hoverTimeout) {
					clearTimeout(this.hoverTimeout)
					this.hoverTimeout = null
				}
			})

			dropdownWrapper.addEventListener('mouseleave', (e) => {
				const relatedTarget = e.relatedTarget
				const isInsideMenu = this.contains(relatedTarget)
				const isInsideDropdown = dropdownWrapper.contains(relatedTarget)

				if (!relatedTarget || (!isInsideMenu && !isInsideDropdown)) {
					this.hoverTimeout = setTimeout(() => {
						if (this.mainDetailsToggle.hasAttribute('open')) {
							this.close()
						}
					}, 800)
				}
			})
		}

		if (menuLink) {
			menuLink.addEventListener('click', (e) => {
				e.stopPropagation()
				e.preventDefault()
				const href = menuLink.getAttribute('href')
				if (href && href !== '#' && href !== '') {
					window.location.href = href
				}
				return false
			})

			summary.addEventListener('click', (e) => {
				if (e.target === menuLink || e.target.closest('.ec-header-menu-link')) {
					e.preventDefault()
					e.stopPropagation()
					return false
				}
			})
		}
  }

  onToggle() {
    if (!this.header || !this.mainDetailsToggle) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
